import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import time from "../../assets/icon/Clip path group.png";
import imgN1 from "../../assets/images/imgN1.png";
import Banner from "../../components/Banner/Banner";
import cateWebService from "../../services/webService/CateWebService";
import imageBanner from "../../assets/images/banner.png"

import article_thumb from "../../assets/images/article_thumb_1.png";

const News = () => {
    const [categories, setCategories] = useState([]);

    const formatDate = (date) => moment.utc(date).format("DD-MM-YYYY HH:mm:ss");

    useEffect(() => {
        try {
            const data = cateWebService.getCategories();
            data.then((res) => {
                if (res?.status === 200) {
                    setCategories(res?.categories);
                } else {
                    toast.warn(res?.status);
                }
            }).catch((err) => {
                toast.error(err);
            });
        } catch (err) {
            toast.error(err);
        }
    }, []);

    return (
        <div className="section-top">
            <div className="container">
                <Banner
                    img={imgN1}
                    bgr={imageBanner}
                >
                    <h2 className="fs-1 fw-bold">Tin tức</h2>
                    <p className="fs-6 mt-3">HPay cung cấp các giải pháp trung gian thanh toán toàn diện với nhiều dịch vụ và tiện ích cho tất cả khách hàng.</p>
                </Banner>
                <div className="section-top-big">
                    {/* {categories.map((cates, index) => (
                        <div key={index} className="row px-3 px-md-5 mb-5 ">
                            <div className="col-12">
                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                    <h2 className="fs-1 fw-bold">{cates.title}</h2>
                                    <Link to={`/tin-tuc/${cates.slug}`} className="button-transparent">
                                        Xem tất cả
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 mt-4">
                                <div className="row">
                                    {cates.articles.map((article) => (
                                        <Link
                                            key={article.id}
                                            to={`/bai-viet/${article.slug}`}
                                            className="col-12 col-md-6 col-lg-4 mb-5 mb-lg-none card-custom"
                                        >

                                            <button className="btn-card">Xem ngay</button>
                                            <div className="d-flex flex-column justify-content-center">
                                                <img src={article.thumbnail_url} className="img-fluid img-card" alt="thumbnail" />

                                                <h4 className="fs-6 text-hover text-uppercase text-limit mt-3" style={{ height: "40px" }}>
                                                    {article.title}
                                                </h4>
                                                <p className="text-lowercase my-2 text-secondary text-limit">{article.description}</p>
                                                <div className="d-flex align-items-center">
                                                    <img src={time} className="img-fluid me-2" alt="" />
                                                    <span className="text-secondary">{formatDate(article.created_at)}</span>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))} */}
                    <div className="row px-3 px-md-5 mb-5 ">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <h2 className="fs-1 fw-bold">{"Thông báo"}</h2>
                                {/* <Link to={`/tin-tuc/${"cates.slug"}`} className="button-transparent">
                                    Xem tất cả
                                </Link> */}
                            </div>
                        </div>
                        <div className="col-12 mt-4">
                            <div className="row">
                                <Link
                                    key={"article.id"}
                                    to={`/bai-viet/cap-nhat-va-bo-sung-thong-tin`}
                                    className="col-12 col-md-6 col-lg-4 mb-5 mb-lg-none card-custom"
                                >

                                    <button className="btn-card">Xem ngay</button>
                                    <div className="d-flex flex-column justify-content-center">
                                        <img src={article_thumb} className="img-fluid img-card" alt="thumbnail" />

                                        <h4 className="fs-6 text-hover text-uppercase text-limit mt-3" style={{ height: "30px" }}>
                                            Yêu cầu cập nhật thông tin Ví Hpay
                                        </h4>
                                        <p className="text-lowercase my-2 text-secondary text-limit">Rà soát, cập nhật và bổ sung thông tin định danh Ví điện tử Hpay</p>
                                        <div className="d-flex align-items-center">
                                            <img src={time} className="img-fluid me-2" alt="" />
                                            <span className="text-secondary">10-10-2026</span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default News;
